import { create } from "zustand";
import { devtools } from "zustand/middleware";
import moment from "moment";
import { getCBFilterData } from "../../api";

const initialState = {
  chargebacksData: {
    transactions: [],
    chargebacks: [],
    ratios: [],
    amounts: {
      transactions: [],
      chargebacks: [],
    },
  },
  chargebackScoreboard: {
    new: 0,
    new_amount: 0,
    pending: 0,
    pending_amount: 0,
    won: 0,
    won_amount: 0,
    loss: 0,
    loss_amount: 0,
    total: 0,
  },
  chargebackScoreboardLoading: false,
  volumeFilter: {
    type: "volume",
  },
  filters: {
    dateRange: {
      startDate: moment().startOf("month").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      rangeType: "MTD",
    },
    searchTerm: "",
    cards: [],
    amount: {
      from: "",
      to: "",
    },
    daysToRebut: {
      from: "",
      to: "",
    },
    isDaysToRebutNull: true,
    reasons: [],
    orgFilter: "",
  },
  chargebacks: [],
  loading: false,
  filterDataLoading: false,
  filterData: {
    max_cb_amount: 0,
    min_cb_amount: 0,
    max_days_to_rebut: 1,
    min_days_to_rebut: 0,
    cb_reasons: [
      {
        label: "104 - Fraud - Fraud Card-Absent Environment",
        valye: "104 - Fraud - Fraud Card-Absent Environment",
      },
      {
        label: "4837 - No Cardholder Authorization",
        valye: "4837 - No Cardholder Authorization",
      },
      {
        label: "C08 - Goods/Services Not Received/Partially Received",
        valye: "C08 - Goods/Services Not Received/Partially Received",
      },
    ],
    card_types: ["VD", "MD", "AM", "VS", "MC", "DS", "MB", "VB"],
  },
};

const useChargebackStore = create(
  devtools((set) => ({
    ...initialState,
    setChargebacksData: (data) => set({ chargebacksData: data }),
    setChargebackScoreboard: (data) => set({ chargebackScoreboard: data }),
    setChargebackScoreboardLoading: (loading) =>
      set({ chargebackScoreboardLoading: loading }),
    setVolumeFilter: (filter) =>
      set((state) => ({
        volumeFilter: { ...state.volumeFilter, ...filter },
      })),
    setFilters: (filters) =>
      set((state) => ({
        filters: { ...state.filters, ...filters },
      })),
    setChargebacks: (chargebacks) => set({ chargebacks }),
    setLoading: (loading) => set({ loading }),
    reset: () => set(initialState),
  })),
);

export const fetchCBFilterData = async () => {
  try {
    useChargebackStore.setState({ filterDataLoading: true });
    const response = await getCBFilterData();
    if (response.status) {
      useChargebackStore.setState({
        filterData: response.data,
        filterDataLoading: false,
      });
    }
  } catch (err) {
    console.error("cb filter data fetch error", err);
    useChargebackStore.setState({
      filterDataLoading: false,
    });
  }
};

export default useChargebackStore;
